import type { ListScrapingIntentRunsParams, ListScrapingIntentsParams } from '../apis';

export const scrapingQueryKeys = {
  all: ['scraping'] as const,
  intents: () => [...scrapingQueryKeys.all, 'intents'] as const,
  intentLists: () => [...scrapingQueryKeys.intents(), 'list'] as const,
  intentList: (params: ListScrapingIntentsParams) =>
    [...scrapingQueryKeys.intentLists(), params] as const,
  intentDetails: () => [...scrapingQueryKeys.intents(), 'detail'] as const,
  intentDetail: (intentId: string) => [...scrapingQueryKeys.intentDetails(), intentId] as const,
  intentRuns: (intentId: string) => [...scrapingQueryKeys.intentDetail(intentId), 'runs'] as const,
  intentRunList: (params: ListScrapingIntentRunsParams) =>
    [...scrapingQueryKeys.intentRuns(params.intentId), params] as const,
  runs: () => [...scrapingQueryKeys.all, 'runs'] as const,
  runDetails: () => [...scrapingQueryKeys.runs(), 'detail'] as const,
  runDetail: (runId: string) => [...scrapingQueryKeys.runDetails(), runId] as const,
  runResults: (runId: string) => [...scrapingQueryKeys.runDetail(runId), 'results'] as const,
  runResultList: (runId: string, params: { limit?: number; cursor?: string }) =>
    [...scrapingQueryKeys.runResults(runId), params] as const,
};
